module.exports = __webpack_public_path__ + "static/feature2-34d81523d5fb03cc460d1ca18326ecaf.png";